import styles from "../../pages/Community/CreateCommunityPage.module.css";

const TabsList = ({
  videoTabs,
  activeTabIndex,
  setActiveTabIndex,
  currentTab,
  setCurrentTab,
  editTabIndex,
  isSubmitting,
  handleAddOrUpdateTab,
  handleEditTab,
  handleDeleteTab,
  handleMoveTabUp,
  handleMoveTabDown,
}) => {
  return (
    <div className={styles.sectionsCard}>
      <h4 className={styles.subSectionTitle}>Tabs</h4>

      <input
        type="text"
        placeholder="Tab name (e.g., Arabic, English)"
        value={currentTab.tab_name}
        onChange={(e) =>
          setCurrentTab({ ...currentTab, tab_name: e.target.value })
        }
        className={styles.textInput}
        disabled={isSubmitting}
      />

      <button
        className={styles.submitButton}
        onClick={handleAddOrUpdateTab}
        disabled={isSubmitting}
      >
        <span>{editTabIndex === -1 ? "Add Tab" : "Update Tab"}</span>
        <span className={styles.submitIcon}>
          {editTabIndex === -1 ? "+" : "✓"}
        </span>
      </button>

      {/* Tabs List */}
      <div className={styles.sectionList}>
        {videoTabs.map((tab, index) => (
          <div
            key={index}
            className={`${styles.sectionRow} ${
              activeTabIndex === index ? styles.activeRow : ""
            }`}
            onClick={() => setActiveTabIndex(index)}
          >
            <div className={styles.reorderButtons}>
              <button
                className={styles.arrowButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveTabUp(index);
                }}
                disabled={index === 0 || isSubmitting}
                title="Move up"
              >
                ▲
              </button>
              <button
                className={styles.arrowButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleMoveTabDown(index);
                }}
                disabled={index === videoTabs.length - 1 || isSubmitting}
                title="Move down"
              >
                ▼
              </button>
            </div>

            <span className={styles.sectionLabel}>{tab.tab_name}</span>

            <div className={styles.sectionActions}>
              <button
                className={styles.editIconButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditTab(index);
                }}
                disabled={isSubmitting}
              >
                ✎
              </button>
              <button
                className={styles.deleteIconButton}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteTab(index);
                }}
                disabled={isSubmitting}
              >
                🗑
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabsList;
